import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { organizationTypeOptions } from '@libs/types/src/mado/enum/organization-type.enum';
import { CheckInputComponent } from '../../../kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../kit/input/text-input/text-input.component';
import { SelectInputComponent } from '../../../kit/input/select-input/select-input.component';

@Component({
    selector: 'app-organization-settings-mado',
    templateUrl: 'organization-settings-mado.component.html',
    imports: [
        CheckInputComponent,
        TextInputComponent,
        SelectInputComponent,
    ]
})
export class OrganizationSettingsMadoComponent {
    public form = input<FormGroup>();

    protected readonly organizationTypeOptions = organizationTypeOptions;
}
